import { render, staticRenderFns } from "./MfaRecovery.vue?vue&type=template&id=21b9b102&scoped=true&"
import script from "./MfaRecovery.vue?vue&type=script&lang=js&"
export * from "./MfaRecovery.vue?vue&type=script&lang=js&"
import style0 from "./MfaRecovery.vue?vue&type=style&index=0&id=21b9b102&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b9b102",
  null
  
)

export default component.exports